import { FindFlowsheetSummariesResponse } from "../Api/Contracts/FindFlowsheetSummaries";
import { FlowsheetEventHistory } from "../Models/FlowsheetEventHistory";
import { FlowsheetSummary } from "../Models/FlowsheetSummary";
import { FlowsheetTemplate } from "../Models/FlowsheetTemplate";

/**
 * Converts a GetFlowsheetSummariesResponse object to an array of FlowsheetSummary objects.
 *
 * @param response - The response object containing flowsheet metadata information.
 * @returns An array of FlowsheetSummary objects.
 */
function findFlowsheetSummariesResponseToFlowsheetSummaries(response: FindFlowsheetSummariesResponse): FlowsheetSummary[] {
    return response.Data.map(flowsheet =>
        new FlowsheetSummary({
            Id: flowsheet.Id,
            EncounterId: flowsheet.EncounterId,
            ApprovalDate: flowsheet.ApprovalDate ? new Date(flowsheet.ApprovalDate) : undefined,
            ApprovedByEmployeeId: flowsheet.ApprovedByEmployeeId,
            Template: new FlowsheetTemplate(flowsheet.Template),
            CreationDate: new Date(flowsheet.CreationDate),
            CreatedByEmployeeId: flowsheet.CreatedByEmployeeId,
            EventHistory: flowsheet.EventHistory.map(history => new FlowsheetEventHistory(
                {
                    EmployeeId: history.EmployeeId,
                    EventType: history.EventType,
                    EventDate: new Date(history.EventDate)
                }
            )) ?? []
        }));
}

export default findFlowsheetSummariesResponseToFlowsheetSummaries;
